import type { SxProps } from '@mui/material/styles';

export const selectionDrawerStyles: SxProps = {
  '& .MuiDrawer-paper': {
    height: '100vh',
    maxHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: 0,
    width: {
      xs: '90vw',
      md: '800px',
      lg: '900px',
      xl: '1000px',
    },
    maxWidth: '90vw',
  },
};
